import css from "./CartPage.module.scss";
import React, { useEffect, useState } from "react";
import { cartItems } from "assets/types";
import { CartCard } from "components/UI/cartCard/CartCard";
import { MyButton } from "components/UI/button/MyButton";
import { cartSum } from "utils/cartSum";
import { cartHandler } from "utils/cartHandler";
import {useSelector} from "react-redux";
import {RootState} from "store/store";

export const CartPage = ({
  cartItems,
  getCartItems,
}: {
  cartItems: cartItems;
  getCartItems: (result: cartItems) => void;
}) => {
  const isMobile = useSelector((state: RootState) => state.mobile);

  const [cartText, setCartText] = useState<string>("В корзине нет товаров");

  useEffect(() => {
    if (cartText === "Спасибо за заказ!") {
      setTimeout(() => {
        setCartText("В корзине нет товаров");
      }, 2000);
    }
  }, [cartText, setCartText]);

  return (
    <main data-testid="cartPage" className={css.page}>
      <h1>Корзина</h1>
      <div className={css.page__line} />
      {cartItems.length > 0 ? (
        <div className={css.page__cards}>
          {cartItems.map((item) => (
            <CartCard
              key={item.info.barcode}
              getCartAction={(result: "+" | "-" | "0") => {
                getCartItems(cartHandler(result, item.info, cartItems));
              }}
              cardData={item}
            />
          ))}
        </div>
      ) : (
        <h3 className={css.page__text}>{cartText}</h3>
      )}
      <div className={css.page__line} />
      {cartItems.length > 0 && (
        <div className={css.page__price}>
          {isMobile && <span>{cartSum(cartItems)} ₸</span>}
          <div
            style={{
              justifySelf: !isMobile ? "flex-start" : "initial",
              width: isMobile ? "100%" : "initial",
            }}
          >
            <MyButton
              width={isMobile ? "100%" : ""}
              maxWidth={isMobile ? "100%" : ""}
              text="Оформить заказ"
              click={() => {
                getCartItems([]);
                setCartText("Спасибо за заказ!");
              }}
            />
          </div>
          {!isMobile && (
            <span
              style={{
                justifySelf: "flex-end",
              }}
            >
              {cartSum(cartItems)} ₸
            </span>
          )}
        </div>
      )}
    </main>
  );
};
